<template>
  <Section
    id="csv-specification"
    :header="t('common.documentation')"
    :loading="loading"
    class="csv-specification"
  >
    <ul class="csv-specification-list flex flex-gap-1 flex-column">
      <li v-for="column in specification.columns" :key="column.fieldName">
        <div class="flex flex-column">
          <h2>{{ column.headerLabel }}</h2>

          <small v-if="column.isRequired" class="p-text-secondary">
            <i>{{ t('common.required') }}</i>
          </small>
        </div>

        <p v-if="column.helpText?.length" class="item-help-text">
          {{ column.helpText }}
        </p>
      </li>
    </ul>
  </Section>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { CsvSpecification } from '@/model';

import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  specification: {
    type: CsvSpecification,
    default: () => new CsvSpecification(),
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const { specification, loading } = toRefs(props);

const { t } = useI18n();
</script>

<style>
.csv-specification {
  .csv-specification-list {
    padding-left: var(--sp-3);

    .item-help-text {
      margin-top: var(--sp-1);
    }
  }
}
</style>
